import { UserSelectValue } from '@dntlab/share-files-dialog';
import { Observable } from 'rxjs';
import { RoleInfo } from '../models/role-info.model';
import { Category, FoldersResponseInner, UserBasic } from '../swagger-api';
import { ProfileInfo } from './profile.interface';

export abstract class ModalDialog {}

export interface DialogButton {
  text: string;
  class: string;
  action: string;
  type?: string;
}

interface DialogdInteraction {
  buttons: DialogButton[];
}

export interface DialogDefaultData extends DialogdInteraction {
  title: string;
  description: string;
}

export interface DialogSelectRoleData extends DialogdInteraction {
  roles: RoleInfo[];
}

export interface DialogActivitiesData extends DialogdInteraction {
  usersList: UserBasic[];
  items: FoldersResponseInner[];
}

export interface DialogSendMessageData extends DialogdInteraction {
  users: UserBasic[];
}

export interface SendEmailDialogData extends DialogDefaultData {
  email: string;
}

export interface CategoryDialog {
  title: string;
  existedCategories: Observable<Category[]>;
}

export interface CreateCategoryDialog extends CategoryDialog {
  createParent: (title: string) => Observable<Category>;
  createChild: (title: string, categoryId: string) => Observable<Category>;
}

export interface UpdateCategoryDialog extends CategoryDialog {
  category: Category;
  update: (categoryId: string, categoryTitle: string, parentId?: string) => Observable<Category>;
}

export interface DialogCropData {
  file: File;
}

export interface UserInfoDialogData {
  title: string;
  userInfo: ProfileInfo[];
}

export interface SendMessageDialogResult {
  message: string;
  participants: UserSelectValue[];
}

export interface SendReactivationPetitionData {
  email: string;
  description: string;
}

export type MessageLevel = 'INFO' | 'WARNING' | 'ERROR' | 'SUCCESS';
export type MessageContentType = 'text' | 'email' | 'signup';

export interface MessageContent {
  value: string;
  type: MessageContentType;
  translateParams?: { [key: string]: string };
}

export interface MessageReply {
  callback: () => void;
  label: string;
}

export interface InformationMessage {
  title: string;
  level: MessageLevel;
  content: MessageContent[];
  replies: MessageReply[];
}

export interface TranslateParams {
  [key: string]: string;
}
